import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const sparePartsListTodo = createAsyncThunk('sparePartsList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `item_master`,
            params: {
                'type': 'Parts',
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const sparePartsListSlice = createSlice({
    name: 'sparePartsList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(sparePartsListTodo.fulfilled, (state, action) => {
           if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                 showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(sparePartsListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default sparePartsListSlice.reducer; 